// extracted by mini-css-extract-plugin
module.exports = {"blogWrapper":"blog_blogWrapper__3q9fC","blogItem":"blog_blogItem__13BRx"};